import { useEffect, useState, useLayoutEffect } from "react";
import { IS_MORE_TOOLS_FORM_SUBMITTED } from './consts';

export const useAutomatedModalState = (numberOfActionsToTriggerModal) => {
  const [userFacedModal, setUserFacedModal] = useState(false);
  const [changeDataTimes, setChangeDataTimes] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useLayoutEffect(() => {
    const receiveHostAppMessage = ({
                                     data: { name, payload },
                                   }) => {
      if (name === IS_MORE_TOOLS_FORM_SUBMITTED) {
        setUserFacedModal(payload);

        if (payload) {
          setIsModalOpen(false);
        }
      }
    };
    window.addEventListener('message', receiveHostAppMessage);
  }, []);

  useEffect(() => {
    if (!userFacedModal && changeDataTimes === numberOfActionsToTriggerModal) {
      setUserFacedModal(true);
      setIsModalOpen(true);
    }
  }, [changeDataTimes, userFacedModal, numberOfActionsToTriggerModal]);

  const triggerActionCounter =
    (actionFunction) =>
    (...actionFunctionArgs) => {
      actionFunction(...actionFunctionArgs);
      setChangeDataTimes((prevChangeDataTimes) => prevChangeDataTimes + 1);
    };

  const onModalClose = () => setIsModalOpen(false);

  return {
    isModalOpen,
    onModalClose,
    triggerActionCounter,
  };
};
